export default "__VITE_ASSET__ChJxJFS5__"